import React from 'react';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { handleError } from 'app/utils/handle-error';
import { config } from 'app/config';
import { AppContext } from 'app/app-context';
import { updateCurrentCustomerLanguage } from 'app/api/customer';

import styles from './top-bar.module.scss';

interface Props {
  variant?: 'primary' | 'secondary';
}

export const TopBar: React.FC<Props> = ({ variant = 'primary' }) => {
  const { t, i18n } = useTranslation();
  const { customerDetails } = React.useContext(AppContext);

  const handleLanguageChange = React.useCallback(
    (language: string) => {
      const changeLanguage = () => i18n.changeLanguage(language);

      if (!customerDetails) {
        changeLanguage().catch(handleError);
        return;
      }

      updateCurrentCustomerLanguage(language).then(changeLanguage).catch(handleError);
    },
    [i18n, customerDetails]
  );

  if (config.availableLanguages.length <= 1) {
    return null;
  }

  return (
    <div className={classNames(styles.topBar, variant === 'secondary' && styles.secondary)}>
      <div className={styles.languages}>
        <Space size="middle">
          {config.availableLanguages.map((language) => (
            <span key={language} className={styles.languageButton} onClick={() => handleLanguageChange(language)}>
              {t(`header.language.${language}`)}
            </span>
          ))}
        </Space>
      </div>
    </div>
  );
};
